module.exports = __webpack_public_path__ + "static/img/index_banner.c18369c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_banner.jpg
// module id = qtsd
// module chunks = 1